import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface InjuredBodyPartsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<InjuredBodyPartsServiceData>(db, 'injuredBodyPartsService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
